import CrownSvg from '@assets/images/svg/crown.svg';
import React from 'react';

export interface CrownIconProps {
    size?: number;
    color?: string;
}

export function CrownIcon({ size = 24, color = '#333333' }: CrownIconProps) {
    return (
        <CrownSvg width={size} height={size} color={color} />
    );
}

export default CrownIcon;
